// 此文件由脚本自动生成，请勿直接修改。
// This file was generated automatically by a script. Please do not modify it directly.

import { StepsTokens } from './type';

const stepsTokens: StepsTokens = {
  stepsDescriptionFontColor: 'Neutral-text-3',
  stepsDescriptionFontSize: 'Font-14',
  stepsDescriptionTitleMarginX: 'Spacing-4',
  stepsIconWidth: 'Size-14',
  stepsIconHeight: 'Size-14',
  stepsIconFontSize: 'Font-16',
  stepsSmallIconWidth: 'Size-12',
  stepsSmallIconHeight: 'Size-12',
  stepsSmallIconFontSize: 'Font-14',
  stepsLargeIconWidth: 'Size-16',
  stepsLargeIconHeight: 'Size-16',
  stepsLargeIconFontSize: 'Font-18',
  stepsTitleFontSize: 'Font-16',
  stepsSmallTitleFontSize: 'Font-14',
  stepsSmallDescriptionFontSize: 'Font-12',
  stepsLargeTitleFontSize: 'Font-18',
  stepsLargeDescriptionFontSize: 'Font-14',
  stepsWaitFontColor: 'Neutral-text-4',
  stepsWaitBackgroundColor: 'Neutral-fill-2',
  stepsWaitHoverFontColor: 'Brand-6',
  stepsProcessFontColor: 'Neutral-text-1',
  stepsProcessBackgroundColor: 'Brand-6',
  stepsFinishFontColor: 'Brand-6',
  stepsFinishBackgroundColor: 'Brand-1',
  stepsFinishHoverFontColor: 'Brand-6',
  stepsErrorFontColor: 'Neutral-text-1',
  stepsErrorBackgroundColor: 'Danger-6',
  stepsArrowPaddingX: 'Spacing-16',
  stepsArrowPaddingY: 'Spacing-8',
  stepsSmallArrowPaddingX: 'Spacing-16',
  stepsSmallArrowPaddingY: 'Spacing-5',
  stepsLargeArrowPaddingX: 'Spacing-16',
  stepsLargeArrowPaddingY: 'Spacing-11',
  stepsTailBackgroundColor: 'Neutral-border-1',
  stepsTailFinishBackgroundColor: 'Brand-6',
  stepsNearlyContentMargin: 'Spacing-8',
  stepsNearlyDescribeMargin: 'Spacing-4',
};

export default stepsTokens;
